<section class="courses-section section-pad">
    <div class="container-fluid px-lg-5">
        <!-- Section Header -->
        <div class="text-center mb-5 animate-on-scroll fade-up">
            <span class="section-badge">Academics</span>
            <h2 class="section-title mt-3">Our Courses</h2>
            <div class="title-underline">
                <span class="line-segment"></span>
                <span class="line-segment accent"></span>
            </div>
            <p class="section-sub mx-auto mt-3">
                Vaish College Samalkha offers three years Graduation degree and 2 years in Post Graduation Degree courses to their students.
            </p>
        </div>

        <!-- Courses Grid -->
        <div class="courses-grid">
            <div *ngFor="let c of courses; let idx = index" class="course-card animate-on-scroll fade-up" [ngClass]="'stagger-' + (idx + 1)">
                <div class="course-card-image-wrap">
                    <img [src]="c.image" [alt]="c.title" 
                         onerror="this.src='https://placehold.co/400x300/cccccc/333333?text='+c.name" />
                    <div class="course-image-overlay"></div>
                    <div class="course-card-text-overlay">
                        <div class="overlay-name">{{ c.name }}</div>
                        <div class="overlay-title">{{ c.title }}</div>
                    </div>
                </div>
                <div class="course-card-footer">
                    <span class="footer-name">{{ c.name }}</span>
                </div>
            </div>
        </div>
    </div>
</section>
